//custom line below, create variable for vip discount
var vipDiscount = 0.85;